import { Toggle } from "~/ui-rtk/components/ui/controls/Toggle"

import { cn } from "~/ui-rtk/utils/tailwind-utils"

export default function HighlightToggle({
  isEnabled,
  toggle,
}: {
  isEnabled?: boolean
  toggle: () => void
}) {
  return (
    <div className="flex justify-end">
      <div
        className={cn(
          "flex items-center gap-system-xs px-system-sm py-system-xxs text-sm rounded-system-md border border-system-blue-600 bg-system-blue-700",
        )}
      >
        <span>Highlight?</span>
        <Toggle size="xs" value={isEnabled} onChange={toggle} />
      </div>
    </div>
  )
}
